import { supabase } from '../lib/supabaseClient';

export const storageService = {
    /**
     * Uploads a file to a specific bucket with a structured path
     */
    async uploadFile(file: File, bucket: string, path: string) {
        // Centralized Size Check: 1000MB
        const MAX_SIZE = 1000 * 1024 * 1024;
        if (file.size > MAX_SIZE) {
            throw new Error(`FILE_TOO_LARGE_FRONTEND`);
        }

        try {
            // 1. Ensure bucket exists (Supabase client will error if not, but we can try to be proactive)
            // Note: Actual bucket creation usually requires service_role or dashboard.

            const { data, error } = await supabase.storage
                .from(bucket)
                .upload(path, file, {
                    upsert: true,
                    cacheControl: '3600'
                });

            if (error) throw error;

            const { data: { publicUrl } } = supabase.storage
                .from(bucket)
                .getPublicUrl(path);

            return publicUrl;
        } catch (error: any) {
            console.error('Storage Upload Error:', error);
            // Translate specific Supabase error
            if (error.message?.includes('exceeded the maximum allowed size')) {
                throw new Error('FILE_TOO_LARGE_BACKEND');
            }
            throw error;
        }
    },

    /**
     * Formats the path for consistent storage organization
     */
    getFilePath(courseId: string, lessonId: string, type: 'videos' | 'documents' | 'thumbnails', filename: string) {
        const timestamp = Date.now();
        const cleanFileName = filename.replace(/[^a-zA-Z0-9.]/g, '_');

        if (type === 'thumbnails') {
            return `courses/${courseId}/thumb_${timestamp}_${cleanFileName}`;
        }

        return `${courseId}/${lessonId}/${type}/${timestamp}_${cleanFileName}`;
    }
};
